// 初始化 Web API（在非 Electron 环境下提供兼容层）
// 必须在其他模块之前导入，确保 window.desktopAPI 已挂载
import './services/webApi.js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { AppDataProvider } from './contexts/AppDataContext.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './index.css'

// 确认 desktopAPI 已挂载
console.log('[main.jsx] desktopAPI 状态:', window.desktopAPI ? '已挂载' : '未挂载');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppDataProvider>
        <App />
      </AppDataProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
